module.exports = __webpack_public_path__ + "static/giftcard-1785947e399bf2823886d39d74e424cd.webp";